<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";

   import EditVehicle from "@/components/custom/edit-vehicle";
    
   export default {
      page: {
         title: "Edit Customer Vehicle",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader, EditVehicle },
      data() {
         return {
            title: "Edit Vehicle",
            items: [
               {
                  text: "Customers",
                  href: "/customers",
               },
               {
                  text: "Vehicles",
                  href: "/vehicles",
               },
               {
                  text: "Edit Vehicle",
                  active: true,
               },        
            ],

            contact_id: null,
            base_route: "customers",

         };
      },
      mounted() {
         this.contact_id = this.$route.params.contact_id;
      },    
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <!-- <router-link :to="{ name: 'customers.vehicles', params: { id: contact_id }  }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link> -->
                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  
                  <EditVehicle :base_route="base_route" />
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
